export function getLocaleFromLocalCache() {
  if (localStorage) {
    return localStorage.getItem("locale");
  }
}
